/**
 * Shared `sx` override for MUI `<Badge>` instances that should pop against
 * the otherwise muted UI. The theme's default `error.main` is `#d32f2f`,
 * which is a fine error red but reads as easy-to-miss against the message-
 * bubble greens and grays in the outreach views. Material's Red A400 is
 * appreciably more saturated, plus we widen the dot variant slightly so the
 * indicator catches the eye.
 *
 * Use with `<Badge sx={brightRedBadgeSx} ... />`.
 */
export const BRIGHT_RED = '#FF1744';

export const brightRedBadgeSx = {
  '& .MuiBadge-badge': {
    backgroundColor: BRIGHT_RED,
    color: '#fff',
    boxShadow: '0 0 0 2px #fff',
  },
  '& .MuiBadge-dot': {
    minWidth: 10,
    height: 10,
    borderRadius: 5,
  },
};
